import create from 'zustand';
import { last } from 'lodash';
import { ILayoutComponentEditorStore } from './LayoutComponentEditor.types';

export const useLayoutComponentEditorStore = create<ILayoutComponentEditorStore>(
  (setState, getState) => ({
    subEditors: [],
    resetSubEditors: () => setState({ subEditors: [] }),
    openSubEditor: (subEditor) => {
      const { subEditors } = getState();
      setState({ subEditors: [...subEditors, subEditor] });
    },
    getSubEditor: () => last(getState().subEditors) ?? null,
    closeSubEditor: () => {
      const { subEditors } = getState();
      setState({ subEditors: subEditors.slice(0, -1) });
    },
  }),
);
